<template>

    <div class="contact-form">

        <div class="success-message" v-if="success === true">{{ t.__('Formularz został przesłany pomyślnie') }}</div>
        <div class="error-message" v-if="success === false">{{ t.__('Nie udało się przesłać formularza') }}</div>

        <b-form-group
            id="contact-name-group"
            description=""
            :label="t.__('Imię i nazwisko')"
            label-for="contact-name"
            valid-feedback=""
            :invalid-feedback="form.errors.get('name')"
            :state="form.errors.state('name')"
            :disabled="processing">
            <b-form-input id="contact-name" v-model="form.name" :state="form.errors.state('name')" trim></b-form-input>
        </b-form-group>

        <b-form-group
            id="contact-email-group"
            description=""
            :label="t.__('Adres e-mail')"
            label-for="contact-email"
            valid-feedback=""
            :invalid-feedback="form.errors.get('email')"
            :state="form.errors.state('email')"
            :disabled="processing">
            <b-form-input id="contact-email" type="email" v-model="form.email" :state="form.errors.state('email')" trim></b-form-input>
        </b-form-group>

        <b-form-group
            id="contact-message-group"
            description=""
            :label="t.__('Wiadomość')"
            label-for="contact-message"
            valid-feedback=""
            :invalid-feedback="form.errors.get('message')"
            :state="form.errors.state('message')"
            :disabled="processing">
            <b-form-textarea id="contact-message" v-model="form.message" max="1000" rows="5" :state="form.errors.state('message')" trim></b-form-textarea>
        </b-form-group>

        <b-button variant="success" class="save-btn float-right" @click="send" :disabled="processing" v-text="processing ? t.__('Wysyłam...') : t.__('Wyślij')"></b-button>


    </div>

</template>

<script>
export default {

    name: "Contact",

    data() {
        return {
            processing: false,
            form: new Vue.prototype.Form({
                name: null,
                email: null,
                message: null
            }),
            success: null
        }
    },

    methods: {
        send() {
            this.processing = true;
            this.form.post('/contact-send')
                .then(response => {
                    this.form.setData({
                        name: null,
                        email: null,
                        message: null
                    })
                    this.processing = false;
                    this.success = true;
                })
                .catch(error => {
                    console.log(error);
                    this.processing = false;
                    this.success = false;
                });
        }
    }
}
</script>

<style scoped>

</style>
